import React, { useState, useEffect, useMemo } from 'react';
import styles from "../styles/gallerysubmodule.module.css";
import GalleryCard from '../../common/GalleryCard';
import { motion } from 'framer-motion';
import axios from 'axios';

const Friends = () => {
  const [photos, setPhotos] = useState([]);

  const apiBase = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios
      .get(`${apiBase}/documents?type=friends&subType=friends`)
      .then((res) => setPhotos(res.data))
      .catch((error) => console.error('Error fetching photos:', error));
  }, [apiBase]);

  const memoizedPhotos = useMemo(() => photos, [photos]);
  const loadingAnimation = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5, delay: 0.2 },
  };

  return (
    <div className={styles.photos}>
      <h4 className={styles.friends_of_snehwan_title}>FRIENDS OF SNEHWAN</h4>
      {memoizedPhotos.length > 0 ? (
        <motion.div
          className={styles['photo-gallery']}
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
          }}
        >
          {memoizedPhotos.map((photo, index) => (
            <div key={index}>
              <GalleryCard photo={photo} />
            </div>
          ))}
        </motion.div>
      ) : (
        <motion.p
          initial="hidden"
          animate="visible"
          variants={loadingAnimation}
        >
          Loading photos...
        </motion.p>
      )}
    </div>
  );
};

export default Friends;
